






























































































































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IUserGroupsProvider,
  IUserGroupsProviderMethods
} from "@/models/providers/userGroups";

@Component
export default class UserGroupsTable extends Vue {
  // Inject

  @Inject({ from: "userGroupsProvider" })
  public userGroupsProvider!: () => IUserGroupsProvider;

  @Inject({ from: "userGroupsProviderMethods" })
  public $userGroupsMеthods!: IUserGroupsProviderMethods;

  // Computed

  public get $userGroupsData() {
    return this.userGroupsProvider();
  }

  public get table() {
    return this.$userGroupsData.table;
  }
}
